import React, { useState, useEffect } from 'react';
import { Modal, Form, Tooltip } from 'antd';
import { Button, Icon } from '@digital/ui';
import TextArea from 'antd/lib/input/TextArea';
import { getJustificativas, salvarJustificativa } from '@app/api/controleQaqc';
import ListMensagem from './ListMensagem';
import { hasPermission } from '@app/helpers/permissions';

export interface PropsModalJustificativas {
  linhaId: string;
  contemComentario: boolean;
}

const ModalJustificativas = (props: PropsModalJustificativas) => {
  const { linhaId, contemComentario } = props;
  const [exibirModal, setExibirModal] = useState(false);
  const [iconeComentario, setIconeComentario] = useState('');
  const [mensagens, setMensagens] = useState([]);
  const textAreaId = `textAreaId${linhaId}`;

  useEffect(() => {
    if (contemComentario === true) {
      MudarIconeAnexo();
    }
  }, []);

  const MudarIconeAnexo = () => {
    setIconeComentario('has-comments');
  };

  const limparCampo = () => {
    const elemento = document.getElementById(textAreaId);
    if (elemento != null) {
      document.getElementById(textAreaId).value = '';
    }
  };

  const handleCancel = () => {
    limparCampo();
    setExibirModal(false);
  };

  const carregarMensagens = () => {
    getJustificativas(linhaId).then(data => {
      setMensagens(data);
    });
  };

  const Salvar = (e: any) => {
    const text = document.getElementById(textAreaId).value;
    const form = new FormData();
    form.append('linhaId', linhaId);
    form.append('justificativa', text);

    salvarJustificativa(form).then(data => {
      if (data.valid) {
        limparCampo();
        carregarMensagens();
      }
    });
  };

  return (
    <>
      <Tooltip title="Comentários">
        <Button
          onClick={() => {
            setExibirModal(true);
            carregarMensagens();
          }}
          icon="messaging-comments"
          className={iconeComentario}
        />
      </Tooltip>
      <Modal
        title="Comentário"
        className="chat-modal"
        visible={exibirModal}
        onCancel={() => {
          handleCancel();
        }}
        footer={[
          <Button key="submitEnviar" type="link" onClick={e => Salvar(e)}>
            Enviar
          </Button>,
          <Button key="submitCancelar" type="primary" onClick={() => handleCancel()}>
            Fechar
          </Button>,
        ]}>
        <ListMensagem mensagens={mensagens} />
        <div className="chat-modal-message-box">
          <Form>
            <Form.Item>
              <TextArea id={textAreaId} placeholder="mensagem" autosize={{ minRows: 3, maxRows: 5 }} maxLength={3000}/>
            </Form.Item>
          </Form>
        </div>
      </Modal>
    </>
  );
};
export default ModalJustificativas;
